import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Icon from "material-ui/Icon";
import moment from "moment";
import Table from "material-ui/Table";
import { TableBody } from "material-ui/Table";
import { TableCell } from "material-ui/Table";
import { TableHead } from "material-ui/Table";
import { TableRow } from "material-ui/Table";
import FiberLengthLossLengthTable from '../fiber/types/components/fiberlengthlosslengthtable'
import FiberLengthLossInsLossTable from '../fiber/types/components/fiberlengthlossinslosstable'

import { withStyles } from "material-ui/styles";
import styles from "./styles";
import { infoData } from "./infoenum";
import { config } from "react-transition-group";
import { isNaviTEKType } from "../../../../../common/utils";

class FiberLengthLossResult extends React.Component {
  constructor(props) {
    super(props);
    const { job } = this.props;

    this.state = {
      isNavitek: job && isNaviTEKType(job.deviceid)
    };
  }

  getTestConfiguration(translate, classes, fiberTestSetup, showFiberQualificationResults) {
    if (!fiberTestSetup) {
      return "-"
    }

    if (showFiberQualificationResults) {
      let testConfig = fiberTestSetup.singlefiber ? translate("1_fiber_loop") : translate("2_fibers_pair")
      if (this.state.isNavitek) {
        return <Typography className={classes.defaultText} color="inherit">
                {testConfig}
             </Typography>
      }
      testConfig += " | " + fiberTestSetup.fibertype
      return <Typography className={classes.defaultText} color="inherit">
                {testConfig}
             </Typography>
    }

    let jumpers = [ translate("one_jumper"), translate("two_jumper"), translate("three_jumper") ]
    let line1 = fiberTestSetup.singlefiber ? translate("single_fiber") : translate("dual_fiber")
    line1 += " | " + fiberTestSetup.fibertype
    line1 += " | " + fiberTestSetup.connectortype

    let line2 = ""
    if (fiberTestSetup.cordref < jumpers.length) {
      line2 += jumpers[fiberTestSetup.cordref] + " | "
    }
    line2 += (fiberTestSetup.bidirectional) ? translate("fiber_test_bidir") : translate("fiber_test_unidir")
    return <Typography className={classes.defaultText} color="inherit">
              {line1}<br/>{line2}
           </Typography>
  }

  render() {
    const {
      job,
      classes,
      result,
      subtest,
      subtestFiberLengthLossResults,
      translate,
      chartMeasurementUnit
    } = this.props;

    const showFiberQualificationResults = job.deviceid !== 'signaltek10g';
    const measurementUnit = chartMeasurementUnit === 'feet' ? '(ft)' : '(m)'
    const fiberLengthData = subtestFiberLengthLossResults && subtestFiberLengthLossResults.lengthdata
    const fiberInsLossData = subtestFiberLengthLossResults && subtestFiberLengthLossResults.linkloss
    const fiberTestSetup = subtestFiberLengthLossResults && subtestFiberLengthLossResults.testsetup
    return subtestFiberLengthLossResults && subtestFiberLengthLossResults.subtesttypeid ? (
      <div ref="container">
        <Paper className={classes.paper}>
          <Grid container>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography color="inherit" className={classes.defaultText}>
                {translate("result_test_started")}
              </Typography>
              <Typography color="inherit" className={classes.defaultText}>
                {subtestFiberLengthLossResults.teststarted
                  ? moment(subtestFiberLengthLossResults.teststarted).format(
                      "DD/MM/YYYY HH:mm:ss"
                    )
                  : ""}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography className={classes.defaultText} color="inherit">
                {translate("result_test_duration")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                {subtestFiberLengthLossResults.testduration
                  ? subtestFiberLengthLossResults.testduration
                  : "00:00:10"}
              </Typography>
            </Grid>
            {!this.state.isNavitek && (
              <Grid item xs={2} className={classes.totalGrid}>
                <Typography className={classes.defaultText} color="inherit">
                  {translate("result_test_limit_standard")}
                </Typography>
                <Typography className={classes.defaultText} color="inherit">
                  {fiberTestSetup
                    ? fiberTestSetup.fiberlimit
                    : "-"}
                </Typography>
              </Grid>
            )}
            <Grid item xs={3} className={classes.totalGrid}>
              <Typography className={classes.defaultText} color="inherit">
                {translate("fibre_test_configuration").toUpperCase()}
              </Typography>
              {this.getTestConfiguration(translate, classes, fiberTestSetup, showFiberQualificationResults)}
            </Grid>
            {!this.state.isNavitek && (
              <Grid item xs={2} className={classes.totalGrid}>
                <Typography className={classes.defaultText} color="inherit">
                  {translate("result_supported_standards")}
                </Typography>
                <Typography className={classes.defaultText} color="inherit">
                  {subtestFiberLengthLossResults.supportedstandards}
                </Typography>
              </Grid>
            )}
            <Grid item xs={1} className={classes.totalGridLast}>
              <Typography
                className={classes.defaultText}
                style={{ marginLeft: "7px" }}
                color="inherit"
              >
                {translate("result_info_status")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                <React.Fragment className={classes.pass}>
                  <div className={classes.infoHead}>
                    {subtestFiberLengthLossResults.subteststatus.toLowerCase() ==
                    "passed" ? (
                      <Icon className={classes.passState}>check_circle</Icon>
                    ) : (
                      <Icon className={classes.failState}>cancel</Icon>
                    )}
                    <div className={classes.infoText}>
                      {infoData.find(
                        o => o.name === subtestFiberLengthLossResults.info
                      )
                        ? " " +
                          translate(
                            infoData.find(
                              o => o.name === subtestFiberLengthLossResults.info
                            ).id
                          )
                        : ""}
                    </div>
                  </div>
                </React.Fragment>
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <h2>{translate('fiber_lengthdata')}</h2>
            <FiberLengthLossLengthTable
              showFiberQualificationResults={showFiberQualificationResults}
              verifyLength={fiberTestSetup.verifylength}
              fiberTestSetup={fiberTestSetup}
              fiberLengthData={fiberLengthData}
              translate={translate}
              chartMeasurementUnit={chartMeasurementUnit}
              measurementUnit={measurementUnit}
              job={job}
            />
          </Grid>

          {!this.state.isNavitek && (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <h2>{translate('fiber_insertionloss_heading')}</h2>
              <FiberLengthLossInsLossTable
                showFiberQualificationResults={showFiberQualificationResults}
                fiberTestSetup={fiberTestSetup}
                fiberInsLossData={fiberInsLossData}
                translate={translate}
                classes={classes}
              />
            </Grid>
          )}
        </Paper>
      </div>
    ) : (
      <Typography type="button">{translate("no_data_sg")}</Typography>
    );
  }
  componentWillMount() {
    const { getsubtestFiberLengthLossResults, subtest, pager } = this.props;

    getsubtestFiberLengthLossResults(pager.jid, pager.tid, subtest, null);
  }
  componentWillReceiveProps(nextProps) {
    const { getsubtestFiberLengthLossResults, subtest, pager } = nextProps;
    if (this.props.pager.tid !== pager.tid || subtest !== this.props.subtest) {
      getsubtestFiberLengthLossResults(pager.jid, pager.tid, subtest, null);
    }
  }
}

export default withStyles(styles)(FiberLengthLossResult);
